import {
  Component,
  OnInit,
  HostListener,
  HostBinding,
  ElementRef,
  Input
} from '@angular/core';

@Component({
  selector: 'awair-dropdown2-wrapper',
  templateUrl: './dropdown-wrapper.component.html',
  styleUrls: ['./dropdown-wrapper.component.scss']
})

export class Dropdown2WrapperComponent implements OnInit {

  @HostListener('document:click', ['$event']) documentClick(event: MouseEvent) {
    this.onDropdownEvent(event, this.el.nativeElement);
  }

  @HostBinding('class.--show') hostShow: boolean = false;
  @HostBinding('class.--small') hostSmall: boolean = false;
  @HostBinding('class.--disabled') hostDisabled: boolean = false;

  @Input() buttonText: string;
  @Input() buttonBadge: string;
  @Input()
  set isSmall(value: boolean) {
    if (value != null) {
      this.hostSmall = value;
    }
  }
  @Input()
  set isDisabled(value: boolean) {
    if (value != null) {
      this.hostDisabled = value;
    }
  }

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
  }

  onDropdownEvent(event: MouseEvent, dropdownContainer: HTMLElement): void {
    this.hostShow = (event.target === dropdownContainer.querySelector('.__dropdown-button')) ? !this.hostShow : false;
  }
}
